import { render, staticRenderFns } from "./PrivacyPolicyHeader.vue?vue&type=template&id=6d0113ec&scoped=true"
import script from "./PrivacyPolicyHeader.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyHeader.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyHeader.vue?vue&type=style&index=0&id=6d0113ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0113ec",
  null
  
)

export default component.exports